import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NavigationPanel = ({ locations, currentLocation, visitedLocations, onNavigate, onClose }) => {
  return (
    <>
      <div className="fixed inset-0 bg-black/50 z-40" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[95vw] max-w-4xl max-h-[85vh] bg-card rounded-lg shadow-2xl z-50 overflow-hidden">
        <div className="flex items-center justify-between p-4 md:p-5 border-b border-border">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">
              Campus Map
            </h2>
            <p className="text-sm text-muted-foreground mt-1">
              {visitedLocations?.length} of {locations?.length} locations explored
            </p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            aria-label="Close map"
          >
            <Icon name="X" size={20} />
          </Button>
        </div>

        <div className="p-4 md:p-6 overflow-y-auto max-h-[calc(85vh-80px)]">
          <div className="relative bg-muted rounded-lg p-8 md:p-12 mb-6" style={{ aspectRatio: '16/9' }}>
            <div className="absolute inset-0 flex items-center justify-center text-muted-foreground">
              <div className="text-center">
                <Icon name="Map" size={48} className="mx-auto mb-2 opacity-50" />
                <p className="text-sm">Interactive Campus Map</p>
              </div>
            </div>

            {locations?.map((location) => {
              const isVisited = visitedLocations?.includes(location?.id);
              const isCurrent = currentLocation === location?.id;

              return (
                <button
                  key={location?.id}
                  className="absolute w-8 h-8 md:w-10 md:h-10 -translate-x-1/2 -translate-y-1/2 group"
                  style={{
                    left: `${location?.coordinates?.x}%`,
                    top: `${location?.coordinates?.y}%`
                  }}
                  onClick={() => onNavigate(location?.id)}
                  aria-label={`Navigate to ${location?.name}`}
                >
                  <div className="relative w-full h-full">
                    {isCurrent && (
                      <div className="absolute inset-0 bg-primary rounded-full animate-ping opacity-75" />
                    )}
                    <div
                      className={`relative w-full h-full rounded-full flex items-center justify-center shadow-lg transition-all group-hover:scale-125 ${
                        isCurrent
                          ? 'bg-primary ring-4 ring-primary/30'
                          : isVisited
                          ? 'bg-success' :'bg-muted-foreground'
                      }`}
                    >
                      <Icon
                        name={isCurrent ? 'MapPin' : isVisited ? 'Check' : 'MapPin'}
                        size={16}
                        color="white"
                      />
                    </div>
                  </div>
                  <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 px-2 py-1 bg-popover border border-border rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10">
                    <p className="text-xs font-medium text-foreground">{location?.name}</p>
                  </div>
                </button>
              );
            })}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {locations?.map((location) => {
              const isVisited = visitedLocations?.includes(location?.id);
              const isCurrent = currentLocation === location?.id;

              return (
                <button
                  key={location?.id}
                  className={`p-4 rounded-lg border-2 text-left transition-all hover:shadow-md ${
                    isCurrent
                      ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
                  }`}
                  onClick={() => onNavigate(location?.id)}
                >
                  <div className="flex items-start gap-3">
                    <div
                      className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
                        isCurrent
                          ? 'bg-primary'
                          : isVisited
                          ? 'bg-success' :'bg-muted'
                      }`}
                    >
                      <Icon
                        name={isCurrent ? 'MapPin' : isVisited ? 'Check' : 'MapPin'}
                        size={20}
                        color="white"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-semibold text-foreground mb-1 flex items-center gap-2">
                        {location?.name}
                        {isCurrent && (
                          <span className="text-xs px-2 py-0.5 bg-primary text-primary-foreground rounded-full">
                            Current
                          </span>
                        )}
                      </h3>
                      <p className="text-sm text-muted-foreground line-clamp-2">
                        {location?.description}
                      </p>
                      <div className="flex items-center gap-2 mt-2">
                        <Icon name="Eye" size={14} color="var(--color-muted-foreground)" />
                        <span className="text-xs text-muted-foreground">
                          {location?.hotspots?.length} points of interest
                        </span>
                      </div>
                    </div>
                    {!isCurrent && (
                      <Icon name="ArrowRight" size={20} color="var(--color-muted-foreground)" />
                    )}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default NavigationPanel;